import React from 'react'
import { NgrsShell } from '../../design/chrome'

export function Layout({ children, crumb = '' }) {
  return <NgrsShell crumb={crumb}>{children}</NgrsShell>
}
